import React from 'react';
import { Map, TileLayer } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import './SearchInterface.css';

const SearchInterface = props => {

   return (
        <div className="searchPanelDiv">
            <h4> Filters</h4><p onClick={props.onClear}>clear</p>
            <input type="text" placeholder="Search" onChange={props.onTextChange} value={props.textValue}/>
               
            <Map 
                ref={props.forwardedRef}
                bounds={props.bounds} 
                onViewportChanged={props.onMapChange}
                style={{ width: "100%", height: "200px"}}>
                <TileLayer 
                   // attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
            </Map>
            <input type="radio" id="intersects" name="spOperation" value="intersects" checked={props.spOperation==="intersects"} onChange={props.onSpOperationChange}/><label htmlFor="intersects">Intersects</label>
            <input type="radio" id="contains" name="spOperation" value="contains" checked={props.spOperation==="contains"} onChange={props.onSpOperationChange}/><label htmlFor="contains">Contains</label>

        </div>
     );
}

export default SearchInterface;